module.exports = __webpack_public_path__ + "img/map.03862f9a.png";